import { Controller } from 'stimulus'
import StimulusReflex from 'stimulus_reflex'

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  connect() {
    StimulusReflex.register(this)
  }

  initialize() {
    StimulusReflex.register(this)
  }

  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  beforeReflex(element, reflex, noop, reflexId) {
    // document.body.classList.add('wait')
  }

  reflexSuccess(element, reflex, noop, reflexId) {
    // show success message
  }

  reflexError(element, reflex, error, reflexId) {
    // show error message
  }

  reflexHalted(element, reflex, error, reflexId) {
    // handle aborted Reflex action
  }

  afterReflex(element, reflex, noop, reflexId) {
    // document.body.classList.remove('wait')
  }

  finalizeReflex(element, reflex, noop, reflexId) {
    // all operations have completed, animation etc is now safe
  }

  confirmDialog(title, message, confirmButtonColor, confirmButtonText = '') {
    return new Promise((resolve, reject) => {
      const dialog = document.createElement('dialog')
      dialog.className =
        'relative z-50 rounded-md transform transition-all shadow-2xl'

      dialog.innerHTML = `
      <div class="sm:max-w-lg sm:w-96 p-4">
        <div class="bg-white ">
          <div class="sm:flex">
            <div class="mt-3 sm:mt-0 w-full">
              <div class="flex justify-center mb-8">
              <div class="p-4 rounded-full flex items-center justify-center bg-red-100">
                <svg width="46" height="46" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-red-500">
                   <path d="M11.9998 9.00006V12.7501M2.69653 16.1257C1.83114 17.6257 2.91371 19.5001 4.64544 19.5001H19.3541C21.0858 19.5001 22.1684 17.6257 21.303 16.1257L13.9487 3.37819C13.0828 1.87736 10.9167 1.87736 10.0509 3.37819L2.69653 16.1257ZM11.9998 15.7501H12.0073V15.7576H11.9998V15.7501Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>            
              </div>
              </div>
              <h3 class="text-xl mb-4 font-semibold leading-6 text-gray-950 text-center" id="modal-title">${title}</h3>
              <div class="mt-2">
                <span class="text-sm text-gray-700 w-full">${message}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 flex justify-center gap-4 content-center">
          <button class="cancel-btn btn-white w-full">Avbryt</button>
          <button class="confirm-btn btn-${confirmButtonColor} w-full">${confirmButtonText === '' ? 'Bekreft' : confirmButtonText}</button>
        </div>
       </div>
    `
      document.body.appendChild(dialog)

      if (typeof dialog.showModal !== 'function') {
        dialogPolyfill.registerDialog(dialog)
      }

      dialog.showModal()

      dialog.querySelector('.confirm-btn').addEventListener('click', () => {
        resolve(true)
        dialog.close()
      })

      dialog.querySelector('.cancel-btn').addEventListener('click', () => {
        resolve(false)
        dialog.close()
      })

      // Handle dialog close event
      dialog.addEventListener('close', () => {
        dialog.remove()
      })
    })
  }
}
